import React from 'react';

import { SwotQuadrant } from './SwotQuadrant';
 
import LoaderHelper from '../../utility/Loading/LoaderHelper';
import StockService from '../../Api_Module/Api_Services/StockService';
import { useParams } from 'react-router-dom';
import { SwotAnalysisState } from '../../interface/ReasearchData';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setSwotAnalysis } from '../../store/ResearchDataSlice';
 

const SwotAnalysis = () => {
  const { symbol } = useParams<{ symbol?: string }>();
  const researchData = useSelector((state: any) => state.researchData);
  const dispatch = useDispatch();
  React.useEffect(() => {
    const fetchSwotAnalysis = async () => {
      if (!symbol) return;
      // Determine if SWOT in store is empty
      const isEmptyArray = (arr: any) => !Array.isArray(arr) || arr.length === 0;
      const isEmptyState = !researchData?.swotAnalysis || (
        isEmptyArray(researchData.swotAnalysis.strengths) &&
        isEmptyArray(researchData.swotAnalysis.weaknesses) &&
        isEmptyArray(researchData.swotAnalysis.opportunities) &&
        isEmptyArray(researchData.swotAnalysis.threats)
      );
      if (isEmptyState) {
        try {
          await getSwotAnalysis();
        } catch (error) {
          console.error('Error fetching SWOT analysis:', error);
        }
      }
    };
    fetchSwotAnalysis();
  }, [symbol]);

  const getSwotAnalysis = async () => {
    try {
      LoaderHelper.loaderStatus(true);
      const result = await StockService.getSwotAnalysis(symbol);
      LoaderHelper.loaderStatus(false);
      if (result?.swot) {
        const swotData: SwotAnalysisState = {
          strengths: result.swot.strengths ? Object.keys(result.swot.strengths).map((item: any, index: number) => ({
            id: index + 1,
            text: result.swot.strengths[item] || ''
          })) : [],
          weaknesses: result.swot.weaknesses ? Object.keys(result.swot.weaknesses).map((item: any, index: number) => ({
            id: index + 1,
            text: result.swot.weaknesses[item] || ''
          })) : [],
          opportunities: result.swot.opportunities ? Object.keys(result.swot.opportunities).map((item: any, index: number) => ({
            id: index + 1,
            text: result.swot.opportunities[item] || ''
          })) : [],
          threats: result.swot.threats ? Object.keys(result.swot.threats).map((item: any, index: number) => ({
            id: index + 1,
            text: result.swot.threats[item] || ''
          })) : []
        };
        dispatch(setSwotAnalysis(swotData));
      }
    } catch (error) {
      console.error("Error fetching SWOT analysis:", error);
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  

  return <div className="rounded-lg shadow-lg overflow-hidden">
    <div className="p-3">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <SwotQuadrant title="Strengths" itemKey={"strengths"} items={researchData.swotAnalysis.strengths} color="green" />
        <SwotQuadrant title="Weaknesses" itemKey={"weaknesses"} items={researchData.swotAnalysis.weaknesses} color="red" />
        <SwotQuadrant title="Opportunities" itemKey={"opportunities"} items={researchData.swotAnalysis.opportunities} color="blue" />
        <SwotQuadrant title="Threats" itemKey={"threats"} items={researchData.swotAnalysis.threats} color="orange" />
      </div>
    </div>
  </div>;
}
export default SwotAnalysis;